<template>
	<div>
		<div class="secsub-left-quescontainer">
			<div class="sec-quescard d-flex flex-column">
				<div
					v-if="showansweroptions"
					@click="showansweroptions = !showansweroptions"
					class="sec-quescardonopen-header d-flex mb-1 align-items-center justify-content-between"
				>
					<div class="sec-quescard-headtext">Communication Question</div>
					<div
						v-if="data.questionKey.slice(-5) == 'INTRO'"
						class="introductorytag fw-500 font-mont fs-10 style-italic color-mainblue"
					>
						Introduction Question
					</div>
					<div class="d-flex pointer" v-else>
						<div class="mr-3">
							<img
								v-b-popover.hover.top="'Edit'"
								src="../../assets/editicon.svg"
								alt=""
								@click="openEditCommunQues(data)"
							/>
						</div>
						<div
							class="mr-3"
							@click.stop="!isLocked ? (deleteModal = !deleteModal) : null"
						>
							<img
								v-b-popover.hover.top="'Delete'"
								src="../../assets/deleteicon.svg"
								alt=""
							/>
						</div>
						<div>
							<img src="../../assets/uparrow.svg" alt="" />
						</div>
					</div>
				</div>

				<div class="d-flex relativeclass">
					<div class="cc-colorbar mt-1"></div>
					<div
						class="ml-3 align-items-center pointer "
						style="width: 95%; padding: 10px 0"
						@click="showansweroptions = true"
					>
						<div class="sec-quescard-headtext" v-if="!showansweroptions">
							Communication Question
						</div>
						<div class="sec-ques-style relativeclass">
							<template v-if="!showansweroptions">
								<div class="relativeclass">
									<div class="d-flex commu-card">
										<div style="white-space: nowrap">Q{{ showindex }}.</div>
										<div
											class="ml-1 topicDescBreak"
											v-html-safe="data.question"
										></div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="relativeclass">
									<div class="d-flex">
										<div style="white-space: nowrap">Q{{ showindex }}.</div>
										<div
											class="ml-1 topicDescBreak"
											v-html-safe="data.question"
										></div>
									</div>
									<template
										v-if="'questionMedia' in data && data.questionMedia != null"
									>
										<div
											v-if="isImage(data.questionMediaType)"
											class="mt-2 mb-2 d-flex align-items-center justify-content-center"
										>
											<div class="relativeclass mb-3">
												<img
													:src="data.questionMedia"
													alt=""
													class="dbmcqcardimage"
												/>
											</div>
										</div>

										<!-- below div comes if audio exists -->
										<div
											v-if="isAudio(data.questionMediaType)"
											class="d-flex mt-2 mb-2 align-items-center justify-content-center"
										>
											<div class="mb-3">
												<Media
													:kind="'audio'"
													:isMuted="false"
													:autoplay="false"
													:controls="true"
													:loop="true"
													class="mcqdatacard-audio"
													:src="data.questionMedia"
												></Media>
											</div>
										</div>
										<div
											v-if="isVideo(data.questionMediaType)"
											class="d-flex mt-2 mb-2 align-items-center justify-content-center"
										>
											<div class="relativeclass mb-3">
												<Media
													:kind="'video'"
													:isMuted="false"
													:src="data.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													class="dbmcqcardimage"
												></Media>
											</div>
										</div>
									</template>
								</div>
							</template>
						</div>
						<div class="sec-icons-style d-flex align-items-center">
							<template
								v-if="
									'questionMedia' in data &&
										data.questionMedia != null &&
										!showansweroptions
								"
							>
								<div
									v-if="isImage(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/image.svg" alt="" />
									<span class="ml-2">Image</span>
								</div>
								<div
									v-if="isAudio(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2">Audio</span>
								</div>
								<div
									v-if="isVideo(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/vedio.svg" alt="" />
									<span class="ml-2">Video</span>
								</div>
							</template>
						</div>
						<div
							class="d-flex"
							style="width: 100%"
							v-if="data.questionTags && data.questionTags.length > 0"
						>
							<div style="width: 80%">
								<div class="d-flex flex-wrap ml-3">
									<div
										class="view-questags pl-2 pr-2 pt-1 pb-1 mr-2 mt-2"
										v-for="qt in questionTags"
										:key="qt"
										v-b-popover.hover.top="qt"
									>
										{{ qt | fnName }}
									</div>
								</div>
							</div>
							<b-input-group-append
								v-if="data.questionTags.length > 6 && questagmore"
								@click="changequestagmore()"
								style="width: 20%"
								class="text-center mt-1"
							>
								<div type="button" class="questag-more-btn">view more</div>
							</b-input-group-append>
							<b-input-group-append
								class="text-center mt-1"
								v-if="data.questionTags.length > 6 && questagmore == false"
								@click="changequestagmore()"
								tyle="width:20%"
							>
								<div type="button" class="questag-more-btn">view less</div>
							</b-input-group-append>
						</div>
					</div>
					<div
						class="d-flex align-items-center pointer mcqcard-downarrow"
						style="width: 3%"
						@click="showansweroptions = !showansweroptions"
					>
						<img
							src="../../assets/downarrow.svg"
							alt=""
							v-if="!showansweroptions"
						/>
					</div>
					<div class="display-mcqcard-mark-tag d-flex align-items-center mt-2">
						<div class="display-card-mark-text">Marks</div>
						<div class="display-card-mark-number ml-2">{{ data.marks }}</div>
					</div>
				</div>
			</div>
		</div>
		<template v-if="showCommunicationModal">
			<CommunicationQuestionModal
				:key="$route.name"
				:showModal="showCommunicationModal"
				:status="communicationType"
				:selectedData="selectedCommunicationQues"
				@close-modal="closeCommunicationModal"
				@get-sections="$emit('get-sections')"
				:fromCard="true"
			/>
		</template>
		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="deleteTopicModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="deleteModal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete the selected question?</span>
			</div>
			<div class="caution-modal-text">
				<b-form-group label="Delete from" v-slot="{ ariaDescribedby }">
					<b-form-radio
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="A"
						>Test only</b-form-radio
					>
					<b-form-radio
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="B"
						>Test and Questionbank</b-form-radio
					>
				</b-form-group>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>

			<div
				@click="deleteComu()"
				class="d-flex align-items-center justify-content-end mt-3"
			>
				<b-button class="addbtn">Delete</b-button>
			</div>
		</b-modal>

		<!-----------------  Delete Popup ends -------->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import CommunicationQuestionModal from "@/components/modals/communicationQuestionModal.vue";
import {
	deleteTestQuesData,
	deleteCommunicationTest,
} from "../../utils/apiFunctions";
import toast from "../../views/mixin/toast";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

export default {
	components: {
		CommunicationQuestionModal,
	},
	mixins: [toast],
	props: {
		data: Object,
		showindex: Number,
		isLocked: Boolean,
	},
	created() {
		console.log(this.data);
	},
	filters: {
		fnName: function(value) {
			if (value.length <= 22) {
				return value.slice(0, 22) + " ";
			} else {
				return value.slice(0, 22) + "...";
			}
		},
	},
	data() {
		return {
			showansweroptions: false,
			showCommunicationModal: false,
			selectedCommunicationQues: {},
			selected: "A",
			deleteModal: false,
			questagmore: true,
		};
	},
	computed: {
		questionTags() {
			if (this.questagmore) {
				return this.data.questionTags.slice(0, 6);
			} else {
				return this.data.questionTags;
			}
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
		}),
	},
	methods: {
		deleteComu() {
			if (this.selected == "A") {
				this.deleteFromTest();
			} else {
				this.deleteFromTestAndDataBank();
			}
		},
		// delete From Test Only
		async deleteFromTest() {
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				marks: this.data.marks,
			};
			const res = await deleteTestQuesData(payload);
			if (res.status == 200) {
				this.successToast("Question deleted successfully!");
				this.$emit("question-deleted");
				this.$emit("get-sections");
			} else {
				this.errorToast("Something went wrong!");
			}
			this.closedeletemodal();
			//close delete modal
		},
		// delete From Test And DataBank
		async deleteFromTestAndDataBank() {
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				marks: this.data.marks,
				addToDatabank: false,
			};
			const res = await deleteCommunicationTest(payload);
			if (res.status == 200) {
				this.$emit("question-deleted");
				this.$emit("get-sections");
				this.successToast("Question deleted successfully!");
			} else {
				this.errorToast("Something went wrong!");
			}
			this.closedeletemodal();
		},
		closedeletemodal() {
			this.deleteModal = false;
		},

		openEditCommunQues(i) {
			this.selectedCommunicationQues = i;
			this.communicationType = "Edit";
			this.showCommunicationModal = true;
		},
		closeCommunicationModal() {
			this.selectedCommunicationQues = {};
			this.showCommunicationModal = false;
		},
		isImage,
		isAudio,
		isVideo,
		changequestagmore() {
			this.questagmore = !this.questagmore;
			this.$forceUpdate();
		},
	},
};
</script>

<style>
.cc-colorbar {
	width: 4px;
	border-radius: 2px;
	margin: 3px;
	background: #7997bf;
}

.display-mcqcard-mark-tag {
	padding: 2px 25px;
	border-radius: 6px 0px 0px 0px;
	position: absolute;
	background: #7997bf;
	bottom: 0px;
	right: 0;
}
.introductorytag {
	padding: 0px 6px;
	background: #e3f2ff;
	border-radius: 6px;
}
</style>
